import { render } from "./EtdSlider.vue?vue&type=template&id=65ea4528"
import script from "./EtdSlider.vue?vue&type=script&lang=js"
export * from "./EtdSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__